import { noop } from '@proc7ts/primitives';
import { zExecutionDone } from './exec-done.impl.js';
/**
 * Performs failed execution.
 *
 * @param reason - A reason of execution failure.
 *
 * @returns Failed execution instance.
 */
export function failZ(reason) {
    const rejection = Promise.reject(reason);
    return {
        whenStarted() {
            return zExecutionDone;
        },
        whenDone() {
            return rejection;
        },
        abort: noop,
    };
}
//# sourceMappingURL=fail.js.map